import { readEnvMockFlag } from "@/utils/envFlag";

/** When true, class admin uses localStorage mock instead of /class/api/v1/* */
export const ADMIN_CLASS_USE_MOCK = readEnvMockFlag(
  import.meta.env.VITE_USE_CLASS_MOCK
);

/** When true, level admin uses localStorage mock instead of /class/api/v1/level/* */
export const ADMIN_LEVEL_USE_MOCK = readEnvMockFlag(
  import.meta.env.VITE_USE_LEVEL_MOCK
);
